import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://rd.frothcrm.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to include token
axiosInstance.interceptors.request.use(
  (config) => {
    // Check for both token keys (global token and self-service token)
    const token = localStorage.getItem("token") || localStorage.getItem("ssToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;